import { DialogTrigger, type DialogTriggerProps } from 'react-aria-components';
import { DialogButton } from './dialog-button';
import { DialogContent } from './dialog-content';
import { DialogDivider } from './dialog-divider';

export type DialogProps = DialogTriggerProps;

function DialogComponent(props: DialogProps) {
  return <DialogTrigger {...props} />;
}

export const Dialog = Object.assign(DialogComponent, {
  Button: DialogButton,
  Content: DialogContent,
  Divider: DialogDivider,
});
